import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminApi, errMsg } from "../../lib/api";
import { eur } from "../../lib/shield";

export const Vouchers = () => {
  const [items, setItems] = useState(null);
  useEffect(() => { adminApi().get("/admin/vouchers").then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  if (!items) return null;
  const sold = items.reduce((t, v) => t + v.amount, 0), left = items.reduce((t, v) => t + v.balance, 0);
  return (
    <section className="mt-10" data-testid="admin-vouchers">
      <div className="eyebrow">Christmas</div>
      <h2 className="font-display text-2xl font-black uppercase">Gift vouchers</h2>
      <p className="mt-1 text-sm text-slate-600" data-testid="admin-vouchers-summary">{items.length} sold · {eur(sold)} total · {eur(sold - left)} redeemed · {eur(left)} still to spend</p>
      {items.length > 0 && (
        <div className="mt-3 max-h-80 overflow-auto border-2 border-slate-200 bg-white">
          <table className="w-full min-w-[640px] text-left text-xs">
            <thead className="sticky top-0 bg-slate-100 uppercase"><tr>{["Code", "Value", "Balance", "Bought by", "For", "Date", "Used on"].map((h) => <th key={h} className="px-3 py-2">{h}</th>)}</tr></thead>
            <tbody>{items.map((v) => (
              <tr key={v.code} className="border-t border-slate-100" data-testid={`admin-voucher-${v.code}`}>
                <td className="px-3 py-1.5 font-mono font-bold">{v.code}</td>
                <td className="px-3 py-1.5">{eur(v.amount)}</td>
                <td className={`px-3 py-1.5 font-bold ${v.balance ? "text-lime-700" : "text-slate-400"}`}>{eur(v.balance)}</td>
                <td className="px-3 py-1.5">{v.buyer.name}<div className="text-slate-400">{v.buyer.email}</div></td>
                <td className="px-3 py-1.5">{v.recipient_name}</td>
                <td className="px-3 py-1.5">{new Date(v.paid_at || v.created_at).toLocaleDateString("en-IE")}</td>
                <td className="px-3 py-1.5">{v.redemptions.map((x) => `${x.order} (${eur(x.amount)})`).join(", ") || "—"}</td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      )}
    </section>
  );
};
